import { render, staticRenderFns } from "./Fase3.vue?vue&type=template&id=ec0292e6&scoped=true"
import script from "./Fase3.vue?vue&type=script&lang=js"
export * from "./Fase3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0292e6",
  null
  
)

export default component.exports